import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import AdminDashboard from "../../AdminDashboard";
import { dict } from "../../../../dictionary";
import { isAuthenticated } from "../../../../auth";
import {
  startBulkWhatsappJob,
  getBulkWhatsappJobStatus,
  listBulkWhatsappJobs,
  resumeBulkWhatsappJob
} from "../../apiAdmin";

function BulkTemplateSender() {
  const [formData, setFormData] = useState();
  const [templateName, setTemplateName] = useState("");
  const [templateLang, setTemplateLang] = useState("ar");
  const [category, setCategory] = useState("MARKETING");

  const [hasHeader, setHasHeader] = useState(false);
  const [headerType, setHeaderType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  const [concurrency, setConcurrency] = useState("3");

  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState(null);
  const [jobs, setJobs] = useState([]);

  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const { user, token } = isAuthenticated();

  useEffect(() => {
    setFormData(new FormData());
    initJobs();
  }, []);

  const initJobs = () => {
    listBulkWhatsappJobs(user._id, token).then(function (res) {
      if (!res) return;
      if (res.error) return;

      var list = res.jobs || [];
      setJobs(list);

      var active = null;
      for (var i = 0; i < list.length; i++) {
        if (list[i].status === "running" || list[i].status === "queued") {
          active = list[i];
          break;
        }
      }

      if (active) {
        setJobId(active._id);
        localStorage.setItem("bulk_whatsapp_last_job", active._id);
      } else {
        setJobId(null);
        setJobStatus(null);
        localStorage.removeItem("bulk_whatsapp_last_job");
      }
    });
  };

  useEffect(() => {
    if (!jobId) return;

    var stopped = false;

    const tick = () => {
      if (stopped) return;

      getBulkWhatsappJobStatus(jobId, user._id, token).then(function (res) {
        if (!res) return;

        if (res.error) {
          setError(res.error);
          return;
        }

        setJobStatus(res);

        if (res.status === "done" || res.status === "failed") {
          setSuccessMsg(res.status === "done" ? dict["done"] || "تم الانتهاء" : dict["failed"] || "فشل");
          localStorage.removeItem("bulk_whatsapp_last_job");

          listBulkWhatsappJobs(user._id, token).then(function (r2) {
            if (r2 && r2.jobs) setJobs(r2.jobs);
          });

          stopped = true;
        }
      });
    };

    tick();
    var timer = setInterval(tick, 3000);

    return function () {
      stopped = true;
      clearInterval(timer);
    };
  }, [jobId]);

  const handleChange = (target) => (event) => {
    setError(null);
    setSuccessMsg(null);

    if (target === "file") formData.set("file", event.target.files[0]);

    if (target === "templateName") {
      setTemplateName(event.target.value);
      formData.set("templateName", event.target.value);
    }

    if (target === "templateLang") {
      setTemplateLang(event.target.value);
      formData.set("templateLang", event.target.value);
    }

    if (target === "category") {
      setCategory(event.target.value);
      formData.set("category", event.target.value);
    }

    if (target === "hasHeader") {
      var v = event.target.checked;
      setHasHeader(v);
      formData.set("hasHeader", v ? "true" : "false");
    }

    if (target === "headerType") {
      setHeaderType(event.target.value);
      formData.set("headerType", event.target.value);
    }

    if (target === "mediaUrl") {
      setMediaUrl(event.target.value);
      formData.set("mediaUrl", event.target.value);
    }

    if (target === "concurrency") {
      setConcurrency(event.target.value);
      formData.set("concurrency", event.target.value);
    }
  };

  const handleOpenConfirmation = (e) => {
    e.preventDefault();

    if (!formData.get("file")) return setError(dict["please_upload_file"] || "يرجى رفع ملف الأرقام");
    if (!templateName) return setError(dict["please_enter_template_name"] || "يرجى إدخال اسم القالب");

    if (hasHeader === true) {
      if (!headerType) return setError(dict["please_select_header_type"] || "يرجى اختيار نوع الهيدر");
      if (!mediaUrl) return setError(dict["please_enter_media_url"] || "يرجى إدخال رابط الميديا");
    }

    setShowModal(true);
  };

  const handleConfirmStart = () => {
    setShowModal(false);

    startBulkWhatsappJob(formData, user._id, token).then(function (res) {
      if (!res || res.error) {
        setError((res && res.error) || "Error");
        return;
      }

      setJobId(res.jobId);
      setJobStatus(null);
      localStorage.setItem("bulk_whatsapp_last_job", res.jobId);
      setSuccessMsg(dict["started"] || "بدأ الإرسال...");
      initJobs();
    });
  };

  const handleResumeJob = (selectedJobId) => {
    setError(null);
    setSuccessMsg(null);

    resumeBulkWhatsappJob(selectedJobId, user._id, token).then(function (res) {
      if (!res || res.error) {
        setError((res && res.error) || "Error");
        return;
      }

      setJobId(res.jobId);
      setJobStatus(null);
      localStorage.setItem("bulk_whatsapp_last_job", res.jobId);
      setSuccessMsg("تم استكمال الإرسال...");
      initJobs();
    });
  };

  const handleClose = () => setShowModal(false);

  const ConfirmationModal = () => {
    return (
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{dict["confirm_action"] || "تأكيد العملية"}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ textAlign: "start" }}>
          {dict["confirm_start_job_msg"] || "هل أنت متأكد أنك تريد بدء عملية الإرسال للقالب: " + templateName + "؟"}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {dict["close"] || "إغلاق"}
          </Button>

          <Button variant="primary" onClick={handleConfirmStart}>
            {dict["start"] || "ابدأ الإرسال"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const showAlert = () => {
    if (error) return <div className="alert alert-danger">{error}</div>;
    if (successMsg) return <div className="alert alert-info">{successMsg}</div>;
  };

  const progressBox = () => {
    if (!jobStatus) return null;

    return (
      <div style={{ marginTop: "15px" }}>
        <b>{jobStatus.status}</b> — {jobStatus.progress}%

        <div>
          total: {jobStatus.total} | ok: {jobStatus.ok} | fail: {jobStatus.fail} | current: {jobStatus.currentIndex || 0}
        </div>

        <div style={{ height: "8px", background: "#eee", marginTop: "5px" }}>
          <div style={{ width: jobStatus.progress + "%", height: "8px", background: "#28a745" }} />
        </div>

        {jobStatus.lastError && (
          <div style={{ marginTop: "8px", color: "#b00020", fontSize: "12px", wordBreak: "break-word" }}>
            {jobStatus.lastError}
          </div>
        )}
      </div>
    );
  };

  const canResume = (j) => {
    if (!j) return false;
    if (j.status === "done") return false;

    var current = j.currentIndex || ((j.ok || 0) + (j.fail || 0));
    var total = j.total || 0;

    return total > 0 && current < total;
  };

  const jobsList = () => {
    if (!jobs.length) return null;

    return (
      <div style={{ marginTop: "20px" }}>
        <h4>{dict["last_jobs"] || "آخر الجوبات"}</h4>

        {jobs.map((j) => (
          <div key={j._id} style={{ border: "1px solid #ddd", padding: "8px", marginBottom: "5px" }}>
            <b>{j.templateName}</b> — {j.status} — {j.progress}%

            <div style={{ fontSize: "12px", marginTop: "4px" }}>
              total: {j.total} | ok: {j.ok} | fail: {j.fail} | current: {j.currentIndex || ((j.ok || 0) + (j.fail || 0))}
            </div>

            {canResume(j) && (
              <button
                type="button"
                onClick={() => handleResumeJob(j._id)}
                className="dashboardBtn"
                style={{ marginTop: "8px", padding: "5px 10px", fontSize: "12px" }}
              >
                استكمال الإرسال
              </button>
            )}
          </div>
        ))}
      </div>
    );
  };

  const form = () => (
    <div className="userProfileDataContainer">
      {showAlert()}

      <h3 className="formContainerTitle">{dict["bulk_whatsapp_send"]}</h3>

      <form>
        <input type="file" className="inputField form-control" onChange={handleChange("file")} />

        <input
          type="text"
          className="inputField form-control"
          placeholder={dict["template_name"]}
          value={templateName}
          onChange={handleChange("templateName")}
        />

        <div style={{ textAlign: "start" }}>
          <input type="checkbox" checked={hasHeader} onChange={handleChange("hasHeader")} /> {dict["has_header"]}
        </div>

        {hasHeader && (
          <>
            <select className="inputField form-control" value={headerType} onChange={handleChange("headerType")}>
              <option value="">اختر النوع</option>
              <option value="image">image</option>
              <option value="video">video</option>
              <option value="document">document</option>
            </select>

            <input
              type="text"
              className="inputField form-control"
              placeholder="ضع الرابط هنا"
              value={mediaUrl}
              onChange={handleChange("mediaUrl")}
            />
          </>
        )}

        <button onClick={handleOpenConfirmation} className="dashboardBtn" style={{ marginTop: "10px" }}>
          {dict["start"]}
        </button>
      </form>

      {progressBox()}
      {jobsList()}
      {ConfirmationModal()}
    </div>
  );

  return (
    <AdminDashboard active="17" data={form} categories={[]} subcategories={[]} newOrders={0} />
  );
}

export default BulkTemplateSender;